<template>
	<div class="spinner-border" 
	:class="[
		small ? 'spinner-border-sm' : '',
		theme ? 'text-'+theme : ''
	]" role="status">
		<span class="sr-only d-none">Chargement ...</span>
	</div>
</template>

<script>

	export default {

		props: {

			small: {
				type: Boolean,
				default: false
			},

			theme: {
				type: String,
				default: 'primary'
			} 

		}

	}

</script>w